module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e3578"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mene_9781418573256_epub_c15_r1#Anch0018",
      "id": "Anch0006"
    }
  }, [_vm._v("GEOGRAPHY ")]), _c('br'), _vm._v(" CHAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e3658"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What rivers converge at Charleston?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e3728"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ashley and Cooper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e3888"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the state’s geographic center?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e3958"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Richland, thirteen miles southeast of Columbia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e4148"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" How many counties does South Carolina have?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4218"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Forty-six.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e4318"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Limestone College, South Carolina’s oldest women’s college, is located in which town known also for its peaches?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4418"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Gaffney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e4528"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What highway winds its way along three lakes and covers one hundred miles through four counties?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4628"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Savannah River Scenic Highway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e4749"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" General P. G. T. Beauregard used what Charleston residence as his headquarters during the Civil War?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4879"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Allen-Rhett Mansion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e4999"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Ross Perot received his highest statewide support (29 percent) in the 1992 presidential election from which tiny town in Colleton County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5209"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Wolfe Creek.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e5309"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The South Carolina shore from the North Carolina border to Winyah Bay is known by what name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5429"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Grand Strand.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e5519"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which town (with above 2,500 population) has the highest percentage of adults with a college degree?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5619"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Clemson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e5719"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What acre of land north of Blackville in Barnwell County is said to have miraculous powers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e5879"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Healing Springs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e6049"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In which York County town are more than 94 percent of residents born outside of South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6179"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Tega Cay.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e6289"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Associate Reformed Presbyterian Church is strongest in which two South Carolina counties?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6389"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" York and Abbeville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e65210"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Among the United States, where does South Carolina rank in area?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e66210"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Fortieth.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e67110"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" One-term Governor David Beasley was born in what small Darlington County town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e68410"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lamar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e69310"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where was Governor Jim Hodges born on November 19, 1956?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e70310"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lancaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e71910"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Berkeley County has a higher percentage of its population belonging to what small denomination than any other U.S. county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e73510"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Reformed Episcopal Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e74410"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the county seat of Berkeley County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e75110"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Moncks Corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e76310"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which Up Country county has the highest percentage of its population belonging to the Wesleyan Church?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e77310"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pickens.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e78310"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Archer Huntington built what Moorish-style structure as a winter home near Murrells Inlet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e79610"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Atalaya.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e80911"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What island is surrounded by Port Royal Sound, Mackay Creek, and Skull Creek?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e82211"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pinckney.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e83211"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In what year did the Wesleyan Church establish Central Wesleyan College (now Southern Wesleyan University)?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e84211"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" 1906.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e85111"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Statesman James Byrnes and author Henry Timrod are buried in what Columbia cemetery?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e86711"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Trinity Cathedral (Episcopal) churchyard.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e87611"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of Presbyterians?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e88311"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" York.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e89211"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Arthur Smith King Mackerel Tournament is held each autumn in what fishing village?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e90211"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Little River.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e91211"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Blue Ridge town served as the old Lower Cherokee capital?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e92211"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Keowee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e93211"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" A Confederate Park is located on Confederate Avenue in what town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e94211"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Rock Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e95412"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Wide Awake is a town in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e96112"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Berkeley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e97012"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" How do South and North Carolina differ in the pronunciation of their towns named Beaufort?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e98012"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" BEW-fort in South Carolina, and BO-fort in North Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e98912"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The only tea plantation in the United States is on what Sea Island?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e99912"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Wadmalaw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e100912"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" With what denomination is Columbia College associated?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e101612"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" United Methodist.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e102512"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town was nearly wiped out during the Yamasee War of 1715 and conquered by the British during the Revolution?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e103812"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Beaufort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e104812"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What sea island is the second largest island in the United States?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e105812"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Johns.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e106712"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What resort town in Horry County is historically African American?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e108012"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Atlantic Beach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e109313"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the name of South Carolina’s northernmost beach?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e110713"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Cherry Grove.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e111713"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Three and Twenty is the name of a town in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e112413"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Anderson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e113313"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The father of what prominent journalist and author owned an estate in Camden called Kamschatka?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e114513"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" William F. Buckley Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e115613"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Forests cover what percentage of the state’s area?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e116313"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sixty-four percent.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e117213"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What South Carolina city has the largest population?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e117913"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Columbia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e118913"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What church near Pageland was organized in 1776 after George Pope received two dreams or visions persuading him to build it?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e120513"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Flat Creek Baptist Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e121513"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What South Carolina city was the first in the United States to adopt the Commission City Manager form of government in 1912?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e122813"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sumter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e124214"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where was the state’s last legal duel fought in 1880?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e124914"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Camden.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e125814"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Francis Marion, the Revolutionary patriot known as the Swamp Fox, is buried at what plantation?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e126814"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Gabriel’s Plantation on Belle Isle.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e128414"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Columbia-based institution is affiliated with the African Methodist Episcopal Church?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e129514"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Allen University.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e130414"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which South Carolina county has the highest percentage of its population not born in the state?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e131414"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Beaufort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e132314"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The South Carolina Railroad, completed in 1833, connected Charleston with what town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e133314"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hamburg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e134314"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of Catholics and Episcopalians in its population?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e135314"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Charleston.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e136214"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town has the highest percentage in the state of its students attending private schools?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e137414"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Forest Acres.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e138615"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Charleston cemetery, dedicated in November 1850, was called “the City of the Silent”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e139615"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Magnolia Cemetery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e140515"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Streets named Raven Drive, Poe Avenue, and Gold Bug are found in which community?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e141515"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sullivan’s Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e142415"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In what year was the Silas N. Pearman Bridge over the Cooper River to Charleston opened?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e144015"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e144915"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What tiny island, home to 150 people, is surrounded by the Waccamaw and Pee Dee Rivers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e146115"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sandy Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e147015"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Long Island was the original name of what elegant resort and residential community?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e148015"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Isle of Palms.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e149015"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is Beachwalker Park?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e150015"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Kiawah Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e151115"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What college in Orangeburg was founded in 1869 as an agricultural school for freed African-Americans?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e152615"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Claflin College.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e154016"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Georgetown Historic District borders what river?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e154716"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sampit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e155716"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where are author DuBose Heyward and statesman John C. Calhoun buried?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e157416"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Saint Philips churchyard, Charleston.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e158416"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" South Carolina Route 61 is known by what familiar name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e159116"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ashley River Road.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e160016"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town, founded in 1711, is South Carolina’s second oldest town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e161016"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Beaufort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e161916"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What park in Charleston County adjoins the Wando River?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e162916"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Palmetto Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e163916"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Edgefield mansion is associated with Governor Andrew Pickens and his ancestors?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e165516"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Halcyon Grove.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e166416"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" At what point do North Carolina, South Carolina, and Georgia join?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e167416"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ellicott’s Rock, named for surveyor Andrew Ellicott.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e169017"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In 1736 what village was founded by Welsh Baptists from Delaware?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e170017"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Society Hill.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e170917"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Sea Island park is known for its Christmas lights?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e171617"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" James Island County Park.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e172517"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" When Charleston was under British control in 1785, where did the state legislature meet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e173517"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Jacksonboro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e174517"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In the Welsh Neck area, what town is the county seat of Marlboro County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e175517"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Bennettsville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e176517"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The coastal region from Charleston south to Savannah goes by what collective name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e177517"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sea Islands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e178517"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is Benedict College?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e179217"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Columbia.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e180117"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Historian and diplomat William Henry Trescot is buried at Saint Paul’s Episcopal churchyard in which Anderson County town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e181717"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pendleton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e183118"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Spartanburg is the site of what Methodist-related college founded in 1854?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e184318"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Wofford.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e185318"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Originally called Salubrity, what town changed its name at the beginning of the American Revolution?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e186618"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Liberty.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e187518"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which South Carolina county has the highest percentage of its population claiming Irish ancestry?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e188518"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Oconee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e189518"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" From what Caribbean Island did many settlers arrive in South Carolina in the seventeenth and eighteenth centuries?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e190518"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Barbados.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e191418"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The town of Beaufort is located on what island?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e192118"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Port Royal Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e193118"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Both Lake Hartwell and Sadlers Creek State Park are located in which county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e194718"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Anderson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e195618"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Established in 1767 in Bluffton, what church is said to be the most photographed place of worship in South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e196918"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Church of the Cross (Episcopal).")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e198219"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" McTeer Memorial Bridge links Lady’s Island with what village?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e199419"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Port Royal.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e200319"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The 1941 Works Progress Administration guide described what town as “a winter resort with great natural beauty”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e201319"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Summerville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e202319"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is South Carolina Route 700 generally called?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e203019"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Maybank Highway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e204119"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What central South Carolina town has a historic synagogue of the Spanish-Sephardic Jewish tradition?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e205419"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sumter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e206419"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Since 1952 what county has supported the Democratic presidential candidates most often?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e207619"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Marlboro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e208619"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The LeNoir Country Store is found in what Sumter County hamlet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e210219"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Horatio.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e211219"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is Presbyterian College?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e211919"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Clinton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e213120"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which town (with above 2,500 population) has the highest percentage of its population born in South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e214120"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lake City (91.3 percent).")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e215020"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" On May 8, 1967, women first served on a South Carolina jury in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e216020"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Anderson.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e216920"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the county seat of Colleton County, settled early in the eighteenth century by rice planters?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e218220"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Walterboro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e219220"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In what county is Shaw Air Force Base?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e219920"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sumter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e220920"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Until the development of rice production in the eighteenth century, what was the most profitable commodity exported from South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e222220"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Deer hides.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e223320"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Containing 350 square miles, what is the smallest county in South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e224320"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" McCormick.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e225320"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Conway is the county seat of what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e226020"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Horry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e227321"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Six Confederate generals were born in which Kershaw County town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e228621"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Camden.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e229521"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" United Methodists comprise the largest denomination in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e230521"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Marlboro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e231421"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the southernmost island off the South Carolina coast?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2311421"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Daufuskie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e232921"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Collectively, what was the nickname for McCormick, Greenwood, Laurens, and Abbeville Counties?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e234821"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Old Ninety-six District.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e235721"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of college-educated adults?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e236721"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Richland.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e237821"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Lutherans comprise the largest denomination in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e238821"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Newberry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e239821"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Willowbrook Cemetery in Edgefield is the final resting place for which notorious U.S. senator?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e241321"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Preston Brooks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e242522"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Horseshoe is the historic area that was the original campus for what university?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e243722"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" University of South Carolina.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e244622"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Financier and presidential adviser Bernard Baruch owned what vast estate in Georgetown County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e245922"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hobcaw Barony.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e247022"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What historically black college in the town of Denmark is affiliated with the Episcopal Church?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e248022"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Voorhees College.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e249122"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Old point refers to the national historic district of what town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e250122"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Beaufort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e251022"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where did the Marquis de Lafayette land when he arrived to join the American Revolutionary forces?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e252022"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" North Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e253022"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Dillon County Museum is located in a former doctor’s office in which town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e254022"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Latta.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e255022"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What women’s college in Spartanburg was founded in 1889?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2155022"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Converse College.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e257023"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has not voted for a Democrat for president since Roosevelt in 1944?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e258023"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lexington.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e258923"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" the ACE Basin National Wildlife Refuge is named for what three rivers that drain into the basin?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e259923"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ashepoo, Combahee, and Edisto.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e261423"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which county has acquired the nickname “the Independent Republic”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e262423"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Horry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e263423"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" While most of Edisto Island is in Charleston County, Edisto Beach is in what other county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e265023"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Colleton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e266023"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Ten governors and five lieutenant governors of South Carolina have come from what small county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e267023"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Edgefield.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e268823"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What name did the Spanish give to their settlements from 1566 to 1587 on today’s Parris Island?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e270223"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Santa Elena.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e271123"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the county seat of Calhoun County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e271823"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Saint Matthews.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e273024"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Lake Monticello is in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e274024"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Fairfield.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e275624"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town near Hilton head is home to the ruins of an old church, a research center devoted to marine life, and factory outlet stores?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e277024"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Bluffton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e278024"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The town of Kershaw is not in Kershaw County, but in what neighboring county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e279624"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lancaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e280524"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Salkehatchie, Combahee, and Coosawatchie Rivers run through what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e282324"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hampton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e283224"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What cemetery is often called South Carolina’s “Little Arlington”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e284224"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Florence National Cemetery.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e285224"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Columbia neighborhood has an eclectic student-oriented character?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e286424"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Five Points.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e287324"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Greenwood is the location of what college founded in 1872?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2817324"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lander University.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e289125"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Of the two Cooper River bridges leading to Charleston, which is the older?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e290125"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" John P. Grace Memorial Bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e291025"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of Southern Baptists?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2911025"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Cherokee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e292425"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the name of the peninsula between the Atlantic Ocean and the Waccamaw River?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e293725"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Waccamaw Neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e294825"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What immigrant group, expelled by the British from Canada, settled briefly near Saint Stephens and Lenud’s Ferry?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e296125"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" French Acadians.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e297025"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In the South Carolina Low Country, what was the name given to the architectural style of many older buildings that were made with crushed oyster shells?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e298325"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Tabby.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e299425"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What predominantly African-American college in Sumter is affiliated with the Baptist Church?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e300725"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Morris College.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e301625"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the only covered bridge in South Carolina?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e302325"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Campbell’s Covered Bridge near Gowensville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e303726"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which community in York County has the state’s highest per capita income?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e304726"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lake Wylie.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e305826"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of its students attending private schools?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e306826"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Jasper.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e307726"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the rolling hill country above the Pine Barrens generally called?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e308926"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Piedmont.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e309826"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Charleston County town is home to the Patriots Point Naval and Maritime Museum?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e310826"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Mount Pleasant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e311726"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What was the nickname given to McCormick County and western Greenwood County early in the\n twentieth century?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e313026"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Dark Corner.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e314026"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What park is a 731-acre peninsula reaching into Lake Thurmond?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e315126"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hamilton Branch State Park.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e316026"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the popular name for South Carolina Route 11?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e316726"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Cherokee Foothills Scenic Highway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e317927"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Presbyterian church between Clemson and Pendleton is the burial place for many pioneers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e319527"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Old Stone Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e320427"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Anderson, Pickens, and Oconee Counties were once known by what name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e322027"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Pendleton District.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e323227"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Town Green in what village has many notable antebellum homes and buildings?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e324227"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Cheraw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e325227"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Several counties in the central uplands region are often called by what name?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e326227"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Olde English District.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e327427"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What historic town has a village green and a shopping district called the Square?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e328627"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pendleton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e329727"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Built in 1790, what house is considered the oldest in Spartanburg?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e330827"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Jammie Seay House.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e332127"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Some streets are built over gold mine tunnels in which Up Country town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e333127"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" McCormick.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e334428"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which church at Cheraw was the last church built under the British monarchy?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e335728"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Old Saint David’s Episcopal Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e336628"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Cruse Vineyards and Winery can be found four miles north of what historic town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e337628"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Chester.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e338528"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Opposite what county courthouse is a wall of fame depicting prominent residents?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e339528"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lancaster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e340428"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" During the American Revolution, Lord Cornwallis made his headquarters at what town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e341728"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Camden.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e342628"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Founded in 1785, what county seat was named for an English statesman?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e343628"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Chesterfield.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e344628"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In which central South Carolina city do 38 percent of residents claim German ancestry?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e345828"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lexington.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e346728"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What colorfully named island lies just off Murrells Inlet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e347728"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Drunken Jack Island.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e348929"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Memorial services are held annually on the second Sunday after Easter at the ruins of what church burned by William T. Sherman in 1865?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e350529"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Sheldon Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e351429"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Blue Row is a group of homes found in what textile town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e352129"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Graniteville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e353129"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town, formerly called Lowry’s turnout, was a way station on the Charleston-Augusta stagecoach route?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e354629"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Bamberg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e355629"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What 102-foot-tall brick tower was the first lighthouse to be built in South Carolina in 1767?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e356629"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Morris Island Lighthouse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e357529"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What town settled by Virginians was once known as Red Hill?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e358529"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Barnwell.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e359629"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What river forms South Carolina’s boundary with Georgia?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e360329"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Savannah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e361229"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which village in Pickens County means “place of mulberries” in the Cherokee Indian language?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e362729"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Keowee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e364130"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Rice Patch and Green Pond are towns in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e364830"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Colleton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e365830"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which county ranks first in percentage of people who earn their living in manufacturing?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e366830"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Calhoun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e367730"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" General Sherman’s troops used which Barnwell church as a stable?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e369030"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Church of the Holy Apostles.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e369930"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Six South Carolina governors and three Confederate generals are buried at which church in Columbia?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e371130"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Trinity Cathedral.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e372030"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In Abbeville what Spanish-style hotel has been renovated and reopened?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e373330"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Belmont Inn.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e374330"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the fifty-thousand-acre recreation site west of Columbia?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e375330"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lake Murray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e376230"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What lighthouse is visible from Folly Beach and James Island?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e377230"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Morris Island Lighthouse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e378531"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Once called Frog Level, what town renamed itself in the 1870s?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e379631"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Prosperity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e380531"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What state park is in Newberry County near Chapin?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e381731"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Dreher Island State Park.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e382831"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the headquarters for the "), _c('i', [_vm._v("Fortune 500 ")]), _vm._v("Sonoco Products Company?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e384431"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hartsville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e385531"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In what county does the highest percentage of the work force earn their living in agriculture?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e386531"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Saluda.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e387531"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Seven miles east of Lake City, what museum includes a farmhouse, a cotton gin, and a smokehouse?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e388731"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Browntown Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e389931"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What tiny town is noted for its ginger ale?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e390631"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Blenheim.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e391631"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Kingstree, the oldest inland settlement in the state, is the county seat for what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e392831"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Williamsburg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e394132"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" In what town on the north shore of Lake Marion can one buy freshly ground grits at Senn’s Grist Mill?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e395432"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Summerton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e396432"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What county has the highest percentage of residents who are age sixty-five or older?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e397432"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Newberry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e398432"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Orangeburg County town calls itself “the Mushroom Capital of the South”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e399732"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Neeses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e400732"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the name given to the area of the state settled by Germans in the eighteenth century?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e401732"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Dutch Fork.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e402632"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What was the last county created in 1919 from parts of Barnwell and Hampton Counties?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e403832"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Allendale.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e404932"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What village stands on the bluff of the May River estuary?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e405632"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Bluffton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e406632"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which county has the largest population?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e407332"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Greenville.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e408533"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the county seat of Jasper County, situated close to the Georgia border?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e409533"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ridgeland.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e410533"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the first South Carolina town on Route 17 near the North Carolina border?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e411533"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Little River.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e412433"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where are Clare Boothe Luce and Henry R. Luce buried?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e413933"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" On the grounds of Mepkin Abbey.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e415133"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which Low Country town calls itself “the Ghost Capital of the World”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e416133"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Georgetown.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e417033"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What historic building, home of the founder of North Augusta, is an official symbol of the city?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e418033"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Look Away Hall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e419033"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" How many county seats have the same name as the county in which they are situated?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e420033"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Thirty-one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e420933"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Saint Matthews, once known for Sea Island cotton, is the county seat of which county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e421933"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Calhoun.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e423134"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the access point for the South Carolina State Palmetto Trail?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e424134"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Mill Creek Park in Pinewood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e425034"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which Up Country town was once noted for its fine cabinet and carriage makers?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e426034"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pendleton.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e427034"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Oconee County seat was named for what garden paradise of the gods in Norse mythology?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e428534"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Walhalla (Valhalla).")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e429634"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" President Abraham Lincoln established what cemetery in 1863 where nine thousand Union soldiers are buried?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e430634"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" National Cemetery in Beaufort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e431534"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What museum in Walterboro is housed in a former jail?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e432534"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Colleton Museum.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e433734"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Which county contains most of South Carolina’s section of the Blue Ridge Mountains?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e434734"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Oconee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e435734"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The U.S. Marine Corps stationed a detachment at what lighthouse during World War II in anticipation of a German attack?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e4351734"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hilton Head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e437935"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Cowpens National Battlefield is located in which town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e438635"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Chesnee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e439635"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the port of Mount Pleasant’s fishing fleet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e440335"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Shem Creek.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e441435"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Civhans Ferry State Park overlooks what river?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e442335"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Edisto.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e443335"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Century House, where Confederate General P. G. T. Beauregard stayed after the Union invasion of Columbia, is in which hamlet?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e445135"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Ridgeway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e446135"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What lighthouse was constructed on Daufuskie Island in 1873?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e447435"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Morris Island Lighthouse.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e448435"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Charleston’s eighteenth-century waterfront district is noted for fourteen colorfully painted private homes with what nickname?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e449735"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Rainbow Row.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e450735"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" The Kings Mountain National Military Park is located in which town?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e451735"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Blacksburg.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e453036"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What Williamsburg County town has the same name as that of a famous American author?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e454336"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Hemingway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e455236"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What symbols are on a relief in front of the Old Newberry Courthouse?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e456536"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" An eagle and a palmetto tree.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e457436"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the county seat of Clarendon County?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e458436"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Manning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e459336"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What is the geographic division that separates the Low Country from the Up Country?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e460336"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Fall Line.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e461236"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is Rear Admiral Victor Blue, a hero of the Spanish-American War, buried?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e462436"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Rose Hill Cemetery in Marion.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e463436"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Nine Times, Pumpkintown, and Rocky Bottom are towns in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e464736"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Pickens.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e465736"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" According to poet Archibald Rutledge, what church has an “indefinable air of austere sanctity”?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e467036"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Saint James Santee Episcopal Church.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e468337"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Where is the Dorchester County seat?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e469337"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Saint George.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e470237"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Green Sea is a town in what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e470937"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Horry.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e471937"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Bishopville, once called Singleton’s Crossroads, is the county seat of which county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e473137"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Lee.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e474037"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What tiny place of worship can be found on U.S. 501 just south of Conway?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e475037"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" The Travelers’ Chapel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e475937"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" Bennettsville is the county seat of what county?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e476837"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Marlboro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e477837"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What South Carolinian, the first U.S. minister to Mexico, is buried at the Church of the Holy Cross in Stateburg?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e479037"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Joel R. Poinsett.")]), _vm._v(" "), _c('p', {
    staticClass: "tx11",
    attrs: {
      "id": "d7e480137"
    }
  }, [_c('b', [_vm._v("Q.")]), _vm._v(" What church in Columbia is modeled on England’s York Minister?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e481137"
    }
  }, [_c('b', [_vm._v("A.")]), _vm._v(" Trinity Cathedral.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68421ea6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mene_9781418573256_epub_c16_r1.vue
// module id = 75
// module chunks = 0